import { BadgeProps } from "@oysterhr/ui"

import {
  EquityWithholdingRequestStatusEnum,
  EquityTypeEnum,
  EquityStatusEnum,
} from "@oysterhr/schema"

export const fragmentMapping = {
  SOP: "",
  RSU: "rsu",
  CSH: "cash-plans",
}

export const SUPPORT_URL = "https://oysterhrsupport1638511837.zendesk.com/hc/en-us/requests/new"

export const equityWithholdingRequestStatusMap: Record<
  EquityWithholdingRequestStatusEnum,
  BadgeProps["variation"]
> = {
  [EquityWithholdingRequestStatusEnum.Cancelled]: "error",
  [EquityWithholdingRequestStatusEnum.Draft]: "gray",
  [EquityWithholdingRequestStatusEnum.Processing]: "warning",
  [EquityWithholdingRequestStatusEnum.Done]: "success",
}

export const headerNames: Record<string, string[]> = {
  [EquityTypeEnum.Csh]: ["due", "award", "receipt"],
  [EquityTypeEnum.Rsu]: ["due", "award", "vesting", "sale"],
  [EquityTypeEnum.Sop]: ["due", "grant", "exercise", "sale"],
}

type Value = {
  color: BadgeProps["variation"]
  translationKey: string
}

type PENDING_HIRE = "PENDING_HIRE"

export const IntentLetterStatusMap: Record<EquityStatusEnum | PENDING_HIRE, Value> = {
  [EquityStatusEnum.Declined]: {
    color: "error",
    translationKey: "status.declined",
  },
  [EquityStatusEnum.Pending]: {
    color: "warning",
    translationKey: "status.pending",
  },
  [EquityStatusEnum.Draft]: {
    color: "gray",
    translationKey: "status.draft",
  },
  [EquityStatusEnum.Done]: {
    color: "success",
    translationKey: "status.done",
  },
  [EquityStatusEnum.InProgress]: {
    color: "info",
    translationKey: "status.inProgress",
  },
  [EquityStatusEnum.ReadyForSignature]: {
    color: "info",
    translationKey: "status.readyForSignature",
  },
  PENDING_HIRE: {
    color: "gray",
    translationKey: "status.pendingHire",
  },
}

export enum GrantLetterTagsEnum {
  IntentLetter = "intent_letter",
  GrantLetter = "grant_letter",
}

export const bulletPoints = [
  "section2.pulledData1",
  "section2.pulledData2",
  "section2.pulledData3",
  "section2.pulledData4",
  "section2.pulledData5",
]

export const numericPoints = [
  "section3.prerequisite1",
  "section3.prerequisite2",
  "section3.prerequisite3",
  "section3.prerequisite4",
]

export const HYPHEN_PLACEHOLDER = "-"
